// extracted by mini-css-extract-plugin
export default {"icon":"icon__M6O4q","center":"center__JyrRd"};